import { FC } from "react";
import { useSelector } from "react-redux";
import { List } from "antd";
import { IDisciplineViewerList } from "Data/interfaces/FederatedViewer/IDisciplineViewerList";
import { IFileData } from "Data/interfaces/ListagemArquivos/IListFilesResponse";
import { getTheme } from "Store/MultiDomain/MultiDomain.selector";
import HighlighterWords from "Components/UI/HighlightWords";
import { Icon } from "Components/UI";
import { iconFileByExtension } from "Utils/Icons";

export const DEFAULT_OBSOLETE_FOLDER_ID = 'default-obsolete-id';

interface IMoveFilesModalListChildren {
  files: IFileData[];
  filteredFiles: IFileData[];
  disciplineFolder: IDisciplineViewerList | null;
  searchFile: string;
  obsoleteFolderId?: string;
  isObsoleteFolder?: boolean;
  onOpenFolder: (
    folderId: string,
    ConstructionSiteDisciplinesId?: number,
    folderName?: string,
    isObsoleteFolder?: boolean,
  ) => void;
}

const MoveFilesModalListChildren: FC<IMoveFilesModalListChildren> = ({
  files,
  filteredFiles,
  disciplineFolder,
  searchFile,
  obsoleteFolderId,
  isObsoleteFolder,
  onOpenFolder,
}) => {
  const { colors } = useSelector(getTheme);

  return (
    <>
      {!isObsoleteFolder && (
        <List.Item
          className="rowDisciplinesList"
          onClick={() => onOpenFolder(
            obsoleteFolderId || DEFAULT_OBSOLETE_FOLDER_ID,
            disciplineFolder?.ConstructionSiteDisciplinesId,
            'Arquivos Obsoletos',
            true,
          )}
        >
          <div className="leftRowDisciplinesList">
            <Icon
              icon="obsoleteArchive"
              customSize={16}
              customColor={colors.surface.onSurfacePlaceholder}
            />
            <HighlighterWords
              text="Arquivos Obsoletos"
              maxLength={65}
              wordSearched={searchFile}
              className="disciplineListText"
            />
          </div>
          <Icon
            icon="retroceder"
            customSize={8}
            className="iconRetroceder"
            customColor={colors.surface.onSurfaceVariant}
          />
        </List.Item>
      )}
      <List
        itemLayout="horizontal"
        dataSource={filteredFiles}
        split={false}
        renderItem={(item: IFileData) => (
          <List.Item
            className={`rowDisciplinesList
              ${!item.IsFolder && !item.inObsoleteFolder ? 'disabledRowDisciplinesList' : ''}
            `}
            onClick={() => (item.IsFolder || item.inObsoleteFolder)
              ? onOpenFolder(
                item.Identifier.ApiId || item.Identifier.ItemId,
                disciplineFolder?.ConstructionSiteDisciplinesId,
                item.Name,
              )
              : undefined
            }
          >
            <div className="leftRowDisciplinesList">
              <Icon
                icon={item.IsFolder
                  ? 'arquivar'
                  : (item.inObsoleteFolder
                    ? 'obsoleteArchive'
                    : iconFileByExtension(item.Extension)
                  )}
                customSize={item.IsFolder
                  ? 12
                  : (item.inObsoleteFolder
                    ? 16
                    : 14
                  )}
                customColor={files.some(file => file.Identifier.ApiId === item.Identifier.ApiId)
                  ? colors.primary.primary
                  : colors.surface.onSurfacePlaceholder
                }
              />
              <HighlighterWords
                text={item.Name}
                maxLength={65}
                wordSearched={searchFile}
                className={`disciplineListText 
                  ${(item.IsFolder || item.inObsoleteFolder)
                    ? ''
                    : 'disciplineListTextOpaco'}
                  ${files.some(file => file.Identifier.ApiId === item.Identifier.ApiId)
                    ? 'disciplineListTextSelected'
                    : ''}
                `}
              />
            </div>
            {(item.IsFolder || item.inObsoleteFolder) && (
              <Icon
                icon="retroceder"
                customSize={8}
                className="iconRetroceder"
                customColor={(item.IsFolder || item.inObsoleteFolder)
                  ? colors.surface.onSurfaceVariant
                  : colors.surface.onSurfacePlaceholder
                }
              />
            )}
          </List.Item>
        )}
      />
    </>
  )
}

export default MoveFilesModalListChildren;
